module.exports = __webpack_public_path__ + "static/media/saas-advantage-icon-3.8822c05b.png";